import { useTheme } from '../../context/ThemeContext.jsx';

export default function MenuOverlay({ onClose, onNavigate, onOpenSearch, onOpenUpload, totalFonts, activatedCount }) {
  const { theme } = useTheme();

  const links = [
    { label: 'library', go: () => onNavigate('library') },
    { label: 'team', go: () => onNavigate('team') },
    { label: 'playground', go: () => onNavigate('playground') },
    { label: 'smart search', go: onOpenSearch },
    { label: 'add fonts.', go: onOpenUpload },
  ];

  return (
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex', background: theme.bg }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '55%', padding: '56px 56px 56px calc(6rem + 24px)',
          display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 10,
        }}
      >
        {links.map((m, i) => (
          <span
            key={m.label}
            onClick={() => { m.go(); onClose(); }}
            style={{
              fontFamily: "'Aeonik', Arial, Helvetica, sans-serif", fontWeight: 500,
              fontSize: 56, lineHeight: 1.05, textTransform: 'lowercase', cursor: 'pointer',
              color: i % 2 === 1 ? theme.text : theme.accent,
            }}
          >{m.label}</span>
        ))}
      </div>

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '45%', background: theme.fill, color: theme.fillFg,
          padding: 48, display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
        }}
      >
        <div>
          <div style={{ fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', opacity: 0.5, marginBottom: 14 }}>the vault</div>
          <div style={{ fontFamily: "'Aeonik', Arial, Helvetica, sans-serif", fontWeight: 400, fontSize: 15, lineHeight: 1.5, marginBottom: 28 }}>
            {totalFonts} font families<br />
            {activatedCount} activated on this machine
          </div>
          <div style={{ fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', opacity: 0.5, marginBottom: 14 }}>need something</div>
          <div style={{ fontFamily: "'Aeonik', Arial, Helvetica, sans-serif", fontWeight: 400, fontSize: 15, lineHeight: 1.5 }}>
            request a font &middot; report a license &middot; it@riester.com
          </div>
        </div>
        <div style={{ display: 'flex', gap: 16, fontSize: 12, letterSpacing: '0.14em', opacity: 0.5 }}>
          <a href="/download" style={{ color: 'inherit', textDecoration: 'none' }}>MACOS APP</a>
        </div>
      </div>
    </div>
  );
}
